<template>
  <div>
    <div class="container btn-flat" style="padding-top: 100px" @click="IrParaPedido()"
         v-if="this.$store.state.pedido.itens.length > 0">
      <footer class="caixa-flutuante-inferior " :style="'background-color:'+this.$store.state.empresa.cor_primaria">
        <div class="col">
          <div class="row" style="padding-left: 10px">
            <a class="btn-flat disabled" style="padding-left: 7px;padding-right: 5px">
          <span style="color: white">
              <i class="material-icons" style="">local_mall</i>
          </span>
            </a>
            <span style="color: white">{{ this.$store.state.pedido.itens.length }}</span>
          </div>
        </div>
        <div class="col">
          <div class="row" style="padding: 0px 0px 6px 0px">
          <span style="color: white; font-weight: 500; font-size: 17px">
              Meu Carrinho
          </span>
          </div>
        </div>
        <div class="col">
          <div class="row" style="padding: 0px 15px 6px 0px">
          <span style="color: white; font-weight: 500; font-size: 17px">
              R$ {{ this.$store.getters.getValorTotalPedido }}
          </span>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "MeuPedidoBlocoFlutuanteComponent",
  methods: {
    IrParaPedido() {
      this.$router.push('/' + this.$store.state.empresa_url + '/pedido');
    }
  }
}
</script>

<style scoped>
.caixa-flutuante-inferior.closed {
  flex-direction: column;
  height: 120px;
  -webkit-box-align: center;
  align-items: center;
}

.caixa-flutuante-inferior {
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: 50px;
  width: 100%;
  box-shadow: rgba(48, 51, 60, 0.25) 0px -1px 2px;
  max-width: 800px;
  padding: 0.50rem 1rem;
  margin: 0px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Widgets/MeuPedidoBlocoFlutuanteComponent.vue